export default __webpack_public_path__ + "static/media/BN.9ebd263c.svg";